import GalleryManager from "../../../gallery/GalleryManager";
import Loader from "../Loader";
import Utils from "./Utils";
import AppSettings from "../../../AppSettings";
import * as api from "../../../net/api";
import { LAYER_TYPE } from "../../../constants";

export default class CanvasUtils {
  constructor(canvas, el) {
    this.root = document.querySelector(".aam-designer-init");
    this.canvas = canvas;
    this.el = el;
    this.loader = new Loader(this.el.parentElement);

    this.uploadResponse;

    // import
    this.galleryManager = new GalleryManager();

    // functional
    this.trimmed;

    // DOM Selection
    this.errorMsg = this.el.querySelector("#coverage-error");
    this.sizeError = this.el.querySelector("#size-error");
    this.uploadError = this.el.querySelector("#upload-error");
    this.confirmBtn = this.el.querySelector(".confirm--button .btn");

    this.utils = new Utils();
  }

  // get canvas ref
  getCanvas() {
    console.log("get canvas", this.canvas);
    return this.canvas;
  }

  dosomething(damsg, callback){
      //alert(damsg);
      if(typeof callback == "function") 
      callback();
  }

  handleControlsVisibility(flag) {
    if (flag) {
      this.el.querySelector(".controls-container").classList.remove("hidden");
      this.el
        .querySelector(".designer-nav-container")
        .classList.remove("hidden");
      this.el
        .querySelector(".features-items-container")
        .classList.add("hidden");
    } else {
      this.el.querySelector(".controls-container").classList.add("hidden");
      this.el.querySelector(".designer-nav-container").classList.add("hidden");
      this.el
        .querySelector(".features-items-container")
        .classList.remove("hidden");
    }
  }

  // designer with canvas rendering 
  showDesignerAfterOptimisation(trimmedCanvas, uploadResponse, optimisedStrokeSign) {
    this.el.classList.add("designer-view");
    
    this.galleryManager.createSignatureGallery(
      uploadResponse.result.Id,
      optimisedStrokeSign
    );

    this.loader.hide();
    
    // add sign to Gallery
    this.addSignatureToCanvas(
      uploadResponse.result,
      trimmedCanvas.width,
      trimmedCanvas.height
    );
    // add sign to canvas
    this.el.querySelector(".optimisation-popup-container").classList.add('hide'); // hide optimisation popup
    this.canvas.maintainGreyOut(true); // show greyout on canvas
    this.createResetObj(); // maintaining initial state for reset
    this.handleControlsVisibility(true); // show Controls
  }

  // Add Trimmed signature to canvas & saving in Signature Gallery as well
  addSignToCanvasHandler(trimmedCanvas, uploadResponse, optimisedStrokeSign, cb) {
    this.el.classList.add("designer-view");
    
    // add sign to Gallery
    this.galleryManager.createSignatureGallery(
      uploadResponse.result.Id,
      optimisedStrokeSign
    );
    
    // add sign to Canvas
    this.addSignatureToCanvas(
      uploadResponse.result,
      trimmedCanvas.width,
      trimmedCanvas.height,
      function() {
        cb();
      }
    );
  }

  // trim canvas and return trimmed solid png
  trimCanvas(canvas) {
    function rowBlank(imageData, width, y) {
      for (let x = 0; x < width; ++x) {
        if (imageData.data[y * width * 4 + x * 4 + 3] !== 0) return false;
      }
      return true;
    }

    function columnBlank(imageData, width, x, top, bottom) {
      for (let y = top; y < bottom; ++y) {
        if (imageData.data[y * width * 4 + x * 4 + 3] !== 0) return false;
      }
      return true;
    }

    const ctx = canvas.getContext("2d");
    const width = canvas.width;
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    let top = 0,
      bottom = imageData.height,
      left = 0,
      right = imageData.width;

    // These functions finds out all those pixels/row/column on canvas, which are blank
    while (top < bottom && rowBlank(imageData, width, top)) ++top;
    while (bottom - 1 > top && rowBlank(imageData, width, bottom - 1)) --bottom;
    while (left < right && columnBlank(imageData, width, left, top, bottom))
      ++left;
    while (
      right - 1 > left &&
      columnBlank(imageData, width, right - 1, top, bottom)
    )
      --right;

    this.trimmed = ctx.getImageData(left, top, right - left, bottom - top);
    const copy = canvas.ownerDocument.createElement("canvas");
    const copyCtx = copy.getContext("2d");
    copy.width = this.trimmed.width;
    copy.height = this.trimmed.height;
    copyCtx.putImageData(this.trimmed, 0, 0);
    const trimmedSolidPNG = copy.toDataURL();
    
    // return
    return trimmedSolidPNG;    
  }

  // get trimmed data
  getTrimmedData() {
    return this.trimmed;
  }

  // Canvas Cameo
  showCanvasInCameo(sw) {
    if (sw) {
      this.root.querySelector(".canvas-container").classList.add("cameo");
      this.canvas.card.hideFadeArea(true);
    } else {
      this.root.querySelector(".canvas-container").classList.remove("cameo");
      this.canvas.card.hideFadeArea(false);
    }
  }

  // add signature to canvas
  addSignatureToCanvas(res, width, height, cb) {
    const image = this.galleryManager
      .getSignatureImages()
      .find((item) => item.Id === res.Id);
    if (image) {
      const selectedObj = this.canvas.getSelectedObject();
      if (selectedObj) {
        selectedObj.done();
        this.canvas.clearSignature();
      }
    }
    this.canvas.removeItems();
    this.canvas.addSignatureItem(image.Id, image.LargeImage, width, height, '', function() {
      if(cb != undefined) {
        cb();
      }
    });
  }

  // reset image - dependent on createRestObj function
  resetImage() {
    this.canvas.resetImage(this.resetObj);

    // resetting UI controls
    this.rangeValue = 100;
    this.root.querySelector("#scale-control").value = 100;
    this.root.querySelector("#scale-control").setAttribute("value", 100);

    this.canvas.testCoverage();
    this.hideCoverageError();
    this.showSizeError(false);
  }

  // create reset object
  createResetObj() {
    const signItem = this.canvas.items.filter(
      (item) => item.type === "Signature"
    )[0];
    this.resetObj = {
      rotation: signItem.rotation,
      width: signItem.width,
      height: signItem.height,
      originPoint: {
        x: signItem.coverageArea.x + signItem.coverageArea.width / 2,
        y: signItem.coverageArea.y + signItem.coverageArea.height / 2,
      },
    };
  }

  showCoverageError(visible) {
    if (visible) {
      this.errorMsg.classList.add("show");
    } else {
      this.errorMsg.classList.remove("show");
    }
  }

  showSizeError(visible) {
    const sizeError = this.sizeError;
    const errorMsgVisible = this.isErrorMsgVisible();
    // If coverage error message is not visible, then only show size error message
    if (errorMsgVisible) {
      sizeError.classList.remove("show");
      AppSettings.isSignatureTooSmall = false;
    } else {
      if (visible) {
        AppSettings.isSignatureTooSmall = true;
        sizeError.classList.add("show");
        this.confirmBtn.classList.add("disabled");
      } else {
        sizeError.classList.remove("show");
      }
    }
  }

  isErrorMsgVisible() {
    const errorMsgs = document.querySelectorAll(".aam-designer-init .error-message");
    let errorVisible = false;
    errorMsgs.forEach(function (elem) {
      if (elem.classList.contains("show")) {
        errorVisible = true;
      }
    });
    return errorVisible;
  }

  hideCoverageError() {
    this.showCoverageError(false);
    this.confirmBtn.classList.remove("disabled");
  }

  makeUploadRequest(croppedSignatureImage) {
    
    const file = this.utils.dataURLtoFile(croppedSignatureImage, "signature.txt");
    const data = new FormData();
    data.append(0, file);

    const request = api.getImageUploadUrlByCustomImageType(
      AppSettings.handoverKey,
      AppSettings.clientId,
      LAYER_TYPE.SIGNATURE
    );

    // create XMLHttpRequest object, adding few event listeners, and POSTing our data
    const oXHR = new XMLHttpRequest();
    oXHR.addEventListener("load", (e) => complete(e), false);
    oXHR.addEventListener("error", (e) => error(e), false);
    oXHR.addEventListener("abort", (e) => error(e), false);
    oXHR.open("POST", request);
    oXHR.send(data);

    const complete = (res) => {
      const uploadRequestResult = JSON.parse(res.target.responseText);
      this.canvas.updateImageObject(uploadRequestResult);
    };

    const error = (e) => {
      console.log("Processed Image not submitted.");
    };
  }
}
